/**
 * True when `url` is an absolute Iris URL (starts with `http`), as opposed to
 * a relative content path that must be resolved through ContentStore.
 *
 * Loose by design — matches the historical `startsWith('http')` checks scattered
 * across the image subsystem. Do not tighten without auditing all callers.
 */
export const isIrisUrl = (url?: string | null): url is string => Boolean(url?.startsWith('http'));
